import {
  HubConnectorInterceptorConfig,
  Storages,
} from '@afe/http-interceptors/hub-connector';
import { urlConfig } from './url.config';

export const hubConnectorInterceptorConfig: HubConnectorInterceptorConfig = {
  urlsToIntercept: [
    urlConfig.auth.urlLogin,
    urlConfig.auth.urlLogout,
    urlConfig.base.urlCrypto,
    urlConfig.url_api_bff
  ],
  storage: {
    keys: {
      jwt: 'jwt',
      xUid: 'x-uid',
    },
    type: Storages.SessionStorage,
  },
  urlsToIgnore: [
    'proposal/validate',
    'proposal/start'
  ],
};
